export default {
  name: 'Transaction |||| Transactions',
  subtitle: 'All transactions (liquidity ledger records are not included)',
  list: {
    title: 'Transactions',
    sender: 'Sender / OutLeg',
    recipient: 'Recipient / InLeg',
    created: 'Date and time',
    baseAmount: 'Base amount',
    instructedAmount: 'Instructed amount',
    operationType: 'Operation type',
    status: 'Status',
    reportingStatus: 'Reporting status',
    settled: 'Settled',
    filters: {
      from: 'Date & time from',
      to: 'Date & time to',
      senderAccountNumber: 'Sender (account number)',
      recipientAccountNumber: 'Recipient (account number)',
      currency: 'Currency',
      baseAmountFrom: 'Base amount from',
      baseAmountTo: 'Base amount to',
      referenceId: 'Reference ID',
      reportStatus: 'Report status',
      reportSystem: 'Report system',
      transactionStatus: 'Transaction status',
      settled: 'Is settled?',
      payerSolutionId: 'Payer solution ID',
      payeeSolutionId: 'Payee solution ID',
      operationType: 'Operation type',
      operationSubtype: 'Operation subtype',
      paymentService: 'Payment service',
      transactionTags: 'Transaction tags',
      tagsHelperText: "To add tag input it's name and press Enter",
      issueResolvedHint: 'Please select issue code',
      issueCode: 'Issue code',
      issueResolved: 'Issue resolution',
      resolved: 'Resolved',
      notResolved: 'Not resolved',
    },
  },
  tabs: {
    details: 'Details',
    batchRecords: 'Batch Records',
    context: 'Context',
    processing: 'Processing',
    integration: 'Integration data',
    actionReports: 'Action reporting',
  },
  aside: {
    details: {
      created: 'Transaction date',
      postingDate: 'Posting date',
      status: 'Status',
      referenceId: 'Reference IDs',
      reporting: 'Reporting',
      tags: 'Transaction tags',
      deal: 'Deal',
      reversalTransaction: 'Reversal transaction',
      revertedTransaction: 'Reverted transaction',
      approvalTransaction: 'Approval transaction',
      approvedTransaction: 'Approved transaction',
      settlementTransaction: 'Settlement transaction',
      settledTransaction: 'Settled transaction',
      payroll: 'Payroll',
      operationType: 'Operation type',
      operationSubtypeOrService: 'Operation subtype or service',
      serviceId: 'Service ID',
      baseAmount: 'Base amount',
      apiChannelType: 'API channel type',
    },
  },
  show: {
    details: {
      transactionDetails: 'Transaction details',
      transfers: 'Transfers',
      bankAccountTransfers: 'Liquidity ledger records',
      created: 'Date and time',
      postingDate: 'Posting date',
      operationType: 'Operation type',
      operationSubtype: 'Operation subtype',
      status: 'Status',
      baseAmount: 'Base amount',
      instructedAmount: 'Instructed amount',
      deal: 'Deal',
      referenceIds: 'Reference IDs',
      sender: 'Sender / OutLeg',
      recipient: 'Recipient / InLeg',
      originator: 'Originator',
      payer: 'Payer',
      payee: 'Payee',
      individual: 'Individual',
      business: 'Business',
      partner: 'Partner',
      tenant: 'Tenant',
      account: 'Veengu account',
      noTransfers: 'No transfers',
      transfer: {
        amount: 'Amount',
        from: 'From / OutLeg',
        to: 'To / InLeg',
        type: 'Transfer operation type',
        postedAt: 'Posted at',
        category: 'Transfer category',
      },
      senderAmounts: 'Sender amounts',
      recipientAmounts: 'Recipient amounts',
      entry: {
        category: 'Type',
        amount: 'Amount',
        transactionAmount: 'Transfer amount',
        totalAmount: 'Total amount',
      },
      bankTransfer: {
        amount: 'Amount',
        from: 'Sender liquidity bucket',
        to: 'Recipient liquidity bucket',
      },
      revertTenantFees: 'Revert tenant fees & taxes',
      reversalParameters: 'Reversal parameters',
      revert: 'Revert transaction',
      revertDialogTitle: 'Revert transaction',
      revertSuccess: 'Transaction successfully reverted',
      cancel: 'Cancel',
      confirm: 'Confirm',
      reason: 'Reason',
      goToTransaction: 'Go to transaction',
      closeDialog: 'Close',
      refundRejected: {
        button: 'Refund rejected transaction',
        dialogTitle: 'Refund rejected transaction',
        warning:
          "The transaction was rejected, but %{amount} was debited from the payer's %{source} and could not be returned automatically. The amount will be credited to the selected wallet account from the tenant account.",
        recipientAccount: 'Recipient account',
        reason: 'Reason',
        cancel: 'Cancel',
        preview: 'Preview',
        confirm: 'Confirm',
        success: 'Rejected transaction successfully refunded',
        close: 'Close',
        goToTransaction: 'Go to transaction',
      },
      revertDanger: `You are creating a reversal transaction. Original transaction amount will be reversed to sender account excluding collected fees & taxes. In case of not sufficient funds, there will be an overdraft on the sender (original recipient) account.
      Be sure you understand of impact on account balances.
      This action is not reversible!`,
      revertDangerWithFees: `You are creating a reversal transaction. Original transaction amount will be reversed to sender account including collected fees & taxes. In case of not sufficient funds, there will be an overdraft on the sender (original recipient) account.
      Be sure you understand of impact on account balances.
      This action is not reversible!`,
      hasPartner:
        "Caution: This transaction involves third-party interaction. Ensure alignment with their system's status.",
      termsAndConditionsVersion: 'Terms and conditions version',
      senderExchangeRate: 'Sender FX rate',
      recipientExchangeRate: 'Recipient FX rate',
      instructedExchangeRate: 'FX rate for instructed amount',
      response: 'Response',
      amount: 'Transaction amount',
      tags: 'Transaction tags',
      beneficiaryAmount: 'Beneficiary amount',
      approve: 'Approve transaction',
      approveDialogTitle: 'Approve transaction',
      approveSuccess: 'Transaction successfully approved',
      approveDanger: `You are creating an approval transaction. All original transaction transfers will be performed.
      Be sure you understand of impact on account balances.
      This action is not reversible!`,
      accountOwner: 'Profile of Veengu account',
      noBankTransfers: 'There are no consolidated account transfers.',
      externalSource: 'External source',
      cancelTransaction: 'Cancel transaction',
      cancelDanger:
        'Cancelling a transaction reverts all financial impacts of the direct transaction and requests to third-party services.',
      cancelDialogTitle: 'Cancel transaction',
      cancelSuccess: 'Transaction successfully cancelled',
      decryptVoucherCode: 'Voucher Code Request',
      decryptVoucherCodeAttention1: 'Attention! Sensitive data.',
      decryptVoucherCodeAttention2: 'Please do not share this code with anyone!',
      voucherCodeReason: 'Reason',
      decryptSecureCode: 'View Secure Code',
      decryptSecureCodeAttention1: 'Attention! Sensitive data.',
      decryptSecureCodeAttention2: 'Please do not share this code with anyone!',
      secureCodeReason: 'Reason',
    },
    processing: {
      transferPlan: 'Transfer Plan',
      accountEffects: 'Account Effects',
      totalBalanceEffect: 'Total Balance Effect',
      balancesAfterPosting: 'Balances after transaction posting',
      selectedPricing: {
        _: 'Selected Pricing',
        transfer: 'Transfer',
        pricing: 'Pricing',
        revision: 'Revision',
      },
      counterEffects: {
        _: 'Counters and Limits Effects',
        code: 'Counter / Limit Code',
        difference: 'Difference',
      },
      disclaimer:
        'This section represents the set of transfers that the System intends to process if the transaction is successfully completed. If the transaction does not reach completion, the information displayed here should be considered only as a planned execution flow and not as the final set of executed transfers. For the exact and final list of transfers generated for a completed transaction, please refer to the Details tab.',
    },
    context: {
      cardTransaction: {
        _: 'Card transaction',
        card: 'Card',
        cardAcceptor: 'Card acceptor',
        parameter: 'Parameter',
        data: 'Data',
        operationSubtype: 'Subtype',
        advice: 'Advice',
        originalAmount: 'Original amount',
        yes: 'Yes',
        no: 'No',
      },
      service: {
        _: 'Service',
        partner: 'Partner',
        processingFlow: 'Processing flow',
        integrationPlugin: 'Integration plugin',
        parameter: 'Parameter',
        data: 'Data',
      },
      serviceCharge: {
        _: 'Service charge',
        deliveryAddress: 'Delivery address',
        id: 'ID',
        name: 'Name',
      },
      originator: {
        _: 'Originator',
        tradeName: 'Trade name',
        employee: 'Team member',
        location: 'Location',
        terminal: 'Terminal',
        paymentToken: {
          STATIC: 'Payment token (static)',
          DYNAMIC: 'Payment token (dynamic)',
        },
        mcc: 'MCC',
        unknownOriginator: 'Unknown',
        originatorProfile: 'Originator profile',
        originatorIdentity: 'Originator identity',
        note: 'Note',
        originatorDevice: 'Originator device',
      },
      senderExternalSource: 'Sender external source',
      recipientExternalSource: 'Recipient external source',
      externalSource: {
        name: 'Name',
        type: 'Type',
        parameter: 'Parameter',
        data: 'Data',
      },
      otherParameters: {
        _: 'Other parameters',
        termsAndConditions: 'Terms and conditions',
        payer: 'payer',
        comment: 'Comment',
        recipientName: 'Recipient name',
        recipientPhoneNumber: 'Recipient phone number',
      },
    },
    integration: {
      responses: {
        _: 'Responses',
        system: 'Third-party',
        code: 'Code',
        message: 'Message',
        noResponses: 'There are no responses from third-party systems.',
      },
      rejectionReasons: {
        _: 'Rejection reasons',
        type: 'Type',
        code: 'Code',
        message: 'Message',
        noReasons: 'There are no rejection reasons for this transaction.',
      },
      transactionIssues: {
        _: 'Transaction issues',
        type: 'Type',
        code: 'Code',
        message: 'Message',
        status: 'Status',
        actions: 'Actions',
        resolved: 'Resolved',
        unresolved: 'Unresolved',
        noReasons: 'There are no issues for this transaction.',
        resolveIssue: 'Resolve issue',
        editResolution: 'Edit resolution',
        viewResolution: 'View resolution details',
        resolutionMessage: 'Resolution message',
        resolutionMessageRequired: 'Resolution message is required',
        resolutionDetails: 'Resolution Details',
        resolvedAt: 'Resolved at',
        resolvedBy: 'Resolved by',
        resolution: 'Resolution',
        cancel: 'Cancel',
        save: 'Save',
        close: 'Close',
      },
      otherTechnicalData: {
        _: 'Other technical data',
        parameter: 'Parameter',
        data: 'Data',
        noOtherTechnicalData: 'There is no other technical data for transaction.',
      },
    },
  },
};
